/**
 * Internal dependencies
 */
// import { createBlock, findTransform } from '../factory';
import { getBlockProps } from "./blocks-parser";
import { findTransform } from "./find-transform";
import { getTransforms } from "./get-transforms";

/**
 * Converts HTML directly to blocks. Looks for a matching transform for each
 * top-level tag. The HTML should be filtered to not have any text between
 * top-level tags and formatted in a way that blocks can handle the HTML.
 *
 * @param {string}   html    HTML to convert.
 * @param {Function} handler The handler calling htmlToBlocks: either rawHandler
 *                           or pasteHandler.
 *
 * @return {Array} An array of blocks.
 */
export function htmlToBlocks(html, handler) {
  const doc = document.implementation.createHTMLDocument("");

  doc.body.innerHTML = html;

  return Array.from(doc.body.children).flatMap((node) => {
    const rawTransform = findTransform(getTransforms(), ({ isMatch }) =>
      isMatch(node),
    );

    if (!rawTransform) {
      return {
        blockSlug: "grigora/html",
        blockProps: {
          content: node.outerHTML,
        },
      };
    }

    const { transform, blockName } = rawTransform;

    if (transform) {
      return transform(node, handler);
    }

    return {
      blockSlug: blockName,
      blockProps: getBlockProps(blockName, node.outerHTML),
    };
  });
}
